import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductosFlujoVentaPasosTiposPreaprobados } from '../_models/productos-flujo-venta-pasos-tipos-preaprobados';

@Injectable({
  providedIn: 'root'
})
export class ProductosFlujoVentaPasosTiposPreaprobadosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosFlujoVentaPasosTiposPreaprobados';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados[]));
  }

  listadoHabilitados() {
    return this.httClient.get(this.rutServicio + '/enabled'  ).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados[]));
  }

  obtenerPorId(idProductoFlujoVentaPasoTipoPreaprobado: string) {
    return this.httClient.get(this.rutServicio + '/' + idProductoFlujoVentaPasoTipoPreaprobado).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados));
  }

  crear(regCrear: ProductosFlujoVentaPasosTiposPreaprobados) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regCrear).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados));
  }

  actualizar(regActualizar: ProductosFlujoVentaPasosTiposPreaprobados) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, regActualizar).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados));
  }

  bulk(registros: ProductosFlujoVentaPasosTiposPreaprobados[]) {
    registros.forEach(e => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httClient.post(`${this.rutServicio}/bulk`, registros).pipe(map(res => res as ProductosFlujoVentaPasosTiposPreaprobados[]));
  }
}
